import { Button, Dialog } from "@buildblockinc/buildblock-design-system";
import { useState } from "react";

interface DeleteDocumentDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  title?: string;
  description?: string;
}

export function DeleteDialog({
  open,
  onClose,
  onDelete,
  title = "Are you sure?",
  description = "You will be unable to recover this item.",
}: DeleteDocumentDialogProps) {
  const [isPending, setIsPending] = useState(false);

  const handleDelete = async () => {
    setIsPending(true);
    try {
      await onDelete();
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.Content className="px-4 pt-8 pb-4">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description className="mt-6">{description}</Dialog.Description>
        <div className="flex gap-2 mt-6">
          <Button type="button" variant="fill" color="secondary" className="flex-1" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="fill"
            color="danger"
            className="flex-1"
            onClick={handleDelete}
            disabled={isPending}
          >
            Delete
          </Button>
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
